import courseInstanceReducer from './courseInstanceReducer'

export default {
  courseInstanceReducer,
}
